import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Route from "./routes/rootRouter";
import Alert from "./components/Toaster";
import "react-datepicker/dist/react-datepicker.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Alert />
    <Route />
  </React.StrictMode>
);
